module.exports = __webpack_public_path__ + "10_hair_silver.e850c6ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/10_hair_silver.png
// module id = XtU9
// module chunks = 0